import React from "react";
import type { AccountInfo } from "@azure/msal-browser";

interface Props {
  account: AccountInfo | null;
  loading: boolean;
  error: string | null;
  hasAdminRole: boolean;
  roles: string[];
  onSignIn: () => void;
  onSignOut: () => void;
  /** Present (and the button shown) only when admin actions are active. */
  onAddAsset?: () => void;
}

export function AdminBar({
  account,
  loading,
  error,
  hasAdminRole,
  roles,
  onSignIn,
  onSignOut,
  onAddAsset,
}: Props) {
  const showNoRoleWarning = account != null && !hasAdminRole;
  const rolesLabel = roles.length === 0 ? "(none)" : roles.join(", ");
  return (
    <div className="admin-bar" role="banner">
      <span className="admin-bar-tag">ADMIN MODE</span>
      <span className="admin-bar-note">
        {showNoRoleWarning ? (
          <>
            Signed in, but missing the <code>DamAdmin</code> role.
            <span className="admin-bar-roles"> Roles in your token: {rolesLabel}</span>
          </>
        ) : (
          "Pre-launch curation tool — IP-firewalled — revert before July go-live"
        )}
      </span>
      <div className="admin-bar-auth">
        {onAddAsset && (
          <button className="admin-bar-btn admin-bar-btn-add" onClick={onAddAsset}>
            + Add asset
          </button>
        )}
        {loading ? (
          <span className="admin-bar-muted">Loading…</span>
        ) : account ? (
          <>
            <span className="admin-bar-user" title={account.username}>{account.username}</span>
            <button className="admin-bar-btn" onClick={onSignOut}>Sign out</button>
          </>
        ) : (
          <button className="admin-bar-btn admin-bar-btn-primary" onClick={onSignIn}>
            Sign in with Microsoft
          </button>
        )}
        {error && <span className="admin-bar-error">{error}</span>}
      </div>
    </div>
  );
}
